import { Component, ElementRef, HostListener, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { QuestionnaireService } from "../services/questionnaire.service";

@Component({
  selector: 'app-end-page',
  templateUrl: './end-page.component.html',
  styleUrls: ['./end-page.component.scss'],
	encapsulation: ViewEncapsulation.Emulated
})
export class EndPageComponent implements OnInit {
  allowsYouList: string[] = ["לשלוח ולקבל את המסמכים הדרושים בלי להגיע לסניף",
                              "להתכתב עם מומחה משכנתאות", 
                              "לתאם פגישה עם הבנקאי שלכם ולהתעדכן בפרטי הפגישה", 
                              "לחשב את סכום המשכנתא וגובה ההחזר החודשי בעזרת מחשבון משכנתא ידידותי",
                              "לקבל מידע על סביבת המגורים שמעניינת אתכם, כלים וטיפים חשובים"];  
  isAdvisor = this.questionnaireService.getIsAdvisor(); 
  asmachta$:Observable<string>;

  @ViewChild('lnkAppstor') lnkAppstor: ElementRef;
  @ViewChild('lnkGooglePlay') lnkGooglePlay: ElementRef;

  constructor(private questionnaireService: QuestionnaireService, private translate: TranslateService) { }

  ngOnInit() {
    this.asmachta$ = this.questionnaireService.getAsmachta$();
  	window.scrollTo(0, 0);
  }

  @HostListener('window:keydown', ['$event'])
	keyEvent(event: KeyboardEvent): any {
		if (event.key === 'Enter') {
      const selectedAriaLabel = (event.target as any).ariaLabel;
			console.log('window:keydown', selectedAriaLabel);
      if (selectedAriaLabel === this.translate.instant('END.LINK_APPLE_STORE')) {
        window.location.href='https://apps.apple.com/il/app/id1597126178';
      } else if (selectedAriaLabel === this.translate.instant('END.LINK_GOOGLE_PLAY')) {
        window.location.href='https://play.google.com/store/apps/details?id=com.MizrahiTefahot.mj&hl=iw&gl=US';
      }
		}

	}

}



// WEBPACK FOOTER //
// ./src/app/end-page/end-page.component.ts